export enum MarquisProfile {
  BLACK,
  GREY,
  WHITE,
}
